module.exports = __webpack_public_path__ + "static/media/generosity.5af41c8a.svg";